import FlightPricesDisclaimerText from './FlightPricesDisclaimerText';

export default FlightPricesDisclaimerText;
